import { nanoid } from '@reduxjs/toolkit';
import { EventParams, getSessionId } from '.';
import { getClient } from '../../lib/info';

export const loadGoogleAnalytics = (measurementId: string): void => {
  if (!measurementId || (window as any).gtag) return;

  const scriptTag = document.createElement('script');
  scriptTag.async = true;
  console.log(
    'MEsSUREMENT ID',
    measurementId,
    `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
  );
  scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(scriptTag);

  (window as any).dataLayer = (window as any).dataLayer || [];
  function gtag() {
    // @ts-ignore
    dataLayer.push(arguments);
  }
  // function gtag(...args: any[]) {
  //   console.log('GA gtag', ...args);
  //   (window as any).dataLayer.push(args);
  // }

  (window as any).gtag = gtag;
  // @ts-ignore
  gtag('js', new Date());
  // @ts-ignore
  gtag('config', measurementId, {
    send_page_view: false, // perché gestiamo noi i pageview
  });
};

export const googleAnnalyticsPageView = (
  url: string,
  title: string,
  isModifying = false
) => {
  console.log(`GA pageView`, {
    page_location: window.location.href,
    page_path: url,
    title: title,
    isModifying,
  });
  if (!(window as any).gtag) return;
  const sessionId = getSessionId();

  (window as any).gtag('event', 'page_view', {
    page_location: window.location.href,
    page_path: url,
    session_id: sessionId,
    title: title,
    isModifying,
  });
};

export const googleAnnalyticsTrackEvent = ({
  action,
  category,
  label,
  value,
  url,
  isModifying = false,
}: EventParams) => {
  console.log(`GA trackEvent`, {
    action,
    event_category: category,
    event_label: label,
    value,
    page_location: window.location.href,
    page_path: url,
    isModifying,
  });
  if (!(window as any).gtag) return;
  const sessionId = getSessionId();
  (window as any).gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
    session_id: sessionId,
    page_location: window.location.href,
    page_path: url,
    isModifying,
  });
};
